var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_368_10331",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.614258,
    y: 0.853516,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_368_10331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6146 15.0202C10.8507 15.0202 11.0488 14.9402 11.2088 14.7802C11.3682 14.6207 11.4479 14.423 11.4479 14.1868C11.4479 13.9507 11.3682 13.7527 11.2088 13.5927C11.0488 13.4332 10.8507 13.3535 10.6146 13.3535C10.3785 13.3535 10.1807 13.4332 10.0213 13.5927C9.86125 13.7527 9.78125 13.9507 9.78125 14.1868C9.78125 14.423 9.86125 14.6207 10.0213 14.7802C10.1807 14.9402 10.3785 15.0202 10.6146 15.0202ZM9.78125 11.6868H11.4479V6.68684H9.78125V11.6868ZM10.6146 19.1868C9.46181 19.1868 8.37847 18.968 7.36458 18.5302C6.3507 18.093 5.46875 17.4993 4.71875 16.7493C3.96875 15.9993 3.37514 15.1174 2.93792 14.1035C2.50014 13.0896 2.28125 12.0063 2.28125 10.8535C2.28125 9.70073 2.50014 8.61739 2.93792 7.60351C3.37514 6.58962 3.96875 5.70767 4.71875 4.95767C5.46875 4.20767 6.3507 3.61378 7.36458 3.17601C8.37847 2.73878 9.46181 2.52017 10.6146 2.52017C11.7674 2.52017 12.8507 2.73878 13.8646 3.17601C14.8785 3.61378 15.7604 4.20767 16.5104 4.95767C17.2604 5.70767 17.854 6.58962 18.2913 7.60351C18.729 8.61739 18.9479 9.70073 18.9479 10.8535C18.9479 12.0063 18.729 13.0896 18.2913 14.1035C17.854 15.1174 17.2604 15.9993 16.5104 16.7493C15.7604 17.4993 14.8785 18.093 13.8646 18.5302C12.8507 18.968 11.7674 19.1868 10.6146 19.1868ZM10.6146 17.5202C12.4757 17.5202 14.0521 16.8743 15.3438 15.5827C16.6354 14.291 17.2813 12.7146 17.2813 10.8535C17.2813 8.99239 16.6354 7.41601 15.3438 6.12434C14.0521 4.83267 12.4757 4.18684 10.6146 4.18684C8.75347 4.18684 7.17708 4.83267 5.88542 6.12434C4.59375 7.41601 3.94792 8.99239 3.94792 10.8535C3.94792 12.7146 4.59375 14.291 5.88542 15.5827C7.17708 16.8743 8.75347 17.5202 10.6146 17.5202Z",
    fill: "#FD7E14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkAlert);
export default __webpack_public_path__ + "static/media/bookmark_alert.2e5dd0c06040b897b8239227fa687dcc.svg";
export { ForwardRef as ReactComponent };